import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Fab, 
  Fade, 
  useScrollTrigger,
  useTheme
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// Easing function for smooth scroll animation
const easeInOutQuad = (t) => {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};

const ScrollToTopButton = () => {
  const theme = useTheme();
  const [isAnimating, setIsAnimating] = useState(false);
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  const handleClick = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const start = window.pageYOffset;
    const duration = 800; // Animation duration in ms
    const startTime = performance.now();

    const animation = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = easeInOutQuad(progress);
      
      window.scrollTo(0, start * (1 - easeProgress));

      if (progress < 1) {
        requestAnimationFrame(animation);
      } else {
        setIsAnimating(false);
      }
    };

    requestAnimationFrame(animation);
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: 'fixed', 
          bottom: theme.spacing(2), 
          right: theme.spacing(2),
          zIndex: 1000
        }}
      >
        <Fab 
          size="small" 
          aria-label="scroll back to top"
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            transition: 'transform 0.2s ease, background-color 0.2s ease',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
              transform: 'scale(1.1)'
            },
            '&:active': {
              transform: 'scale(0.9)'
            }
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Fade>
  );
};

export default ScrollToTopButton; 